export default __webpack_public_path__ + "static/banner-mobile-application-development1-ezgif.com-avif-to-jpg-converter-6ff29621172f22e2a4093b0bb1c0eb2a.jpg";